import { isoDate, object, optional, pipe, string } from 'valibot'

/**
 * 配車板の検索条件
 */
export const vehicleDispatchBoardsSearch = object({
  // 発送日 (配送依頼一覧、配車API呼び出し時の条件に設定する値)
  shippingDate: optional(pipe(string(), isoDate()))
})
